import React, {useEffect,useRef,useState} from "react";
import {OpenSheetMusicDisplay} from "opensheetmusicdisplay";
import QuestionLayout from "./QuestionLayout";
import {RomanNumeralInput} from "./RomanNumeralAnalysis";

export default function SecondaryDominantInput({config,value={},onChange,mode="edit",feedback}) {
  const host=useRef(null),[error,setError]=useState('');
  const source=config.musicXML,width=Number(config.scoreWidth)||360;
  const showImage=config.scoreSourceType ? config.scoreSourceType==='image' : !!config.image;
  useEffect(()=>{
    if(showImage || !source || !host.current)return;
    const target=host.current;let disposed=false;target.replaceChildren();setError('');
    const osmd=new OpenSheetMusicDisplay(target,{backend:'svg',autoResize:false,drawTitle:false,drawSubtitle:false,drawComposer:false,drawPartNames:false,drawMeasureNumbers:false});
    osmd.EngravingRules.RenderChordSymbols=false;
    osmd.EngravingRules.RenderLyrics=false;
    (async()=>{try{await osmd.load(source);if(!disposed)osmd.render();}catch(e){if(!disposed)setError(`Unable to display score: ${e.message}`);}})();
    return ()=>{disposed=true;target.replaceChildren();};
  },[source,showImage,width]);
  const saved=value && typeof value==='object'?value:{};
  const border=id=>mode==='review'&&typeof feedback?.parts?.[id]?.correct==='boolean'
    ?`2px solid ${feedback.parts[id].correct?'#2e7d32':'#c62828'}`:'1px solid #687387';
  return <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
    <div style={{display:'flex',alignItems:'center',gap:36,flexWrap:'wrap'}}>
      {showImage?<img src={config.image} alt={config.imageAlt || 'Chord to analyze'} style={{display:'block',width:Number(config.imageWidth)||260,maxWidth:'100%',height:'auto'}}/>:
        <div style={{width,maxWidth:'100%',overflowX:'auto'}}><div ref={host} style={{width}}/>{error&&<p role="alert">{error}</p>}</div>}
      <div style={{display:'flex',alignItems:'center',gap:10}}>
        <RomanNumeralInput aria-label="Dominant chord (V or V7)" value={saved.first || ''} readOnly={mode!=='edit'}
          onChange={text=>onChange({...saved,first:text})} style={{width:80,height:42,textAlign:'center',border:border('first'),borderRadius:4}} className="rn-font"/>
        <span aria-hidden="true" style={{fontSize:28}}>/</span>
        <RomanNumeralInput aria-label="Target scale degree" value={saved.second || ''} readOnly={mode!=='edit'}
          onChange={text=>onChange({...saved,second:text})} style={{width:80,height:42,textAlign:'center',border:border('second'),borderRadius:4}} className="rn-font"/>
      </div>
    </div>
  </QuestionLayout>;
}
